module.exports = __webpack_public_path__ + "static/media/undraw_Chat_bot_re_e2gj.71a4fbf8.svg";